/** Fixed widths for a pivot prefix, so prefixes in adjacent rows line up.
 *
 * Tailwind needs these spelled out as whole class names — it cannot see a class
 * assembled at runtime — so they are looked up rather than interpolated.
 */
export const PIVOT_PREFIX_WIDTHS = {
  lg: "w-[5em]",
  md: "w-[4em]",
  sm: "w-[3em]",
} as const;

export type PivotPrefixWidth = keyof typeof PIVOT_PREFIX_WIDTHS;
